import React from 'react';
import ActionButtonPanel from '../../Forms/Buttons/ActionButtonPanel';
import { ActionItem } from '../../../types/button/ActionButton';

interface PdfFooterSectionProps {
  actions: ActionItem[];
}

const PdfFooterSection: React.FC<PdfFooterSectionProps> = ({ actions }) => {
  return <ActionButtonPanel actions={actions} />;
};

export default PdfFooterSection;
